import { Component } from '@angular/core';

@Component({
	templateUrl: '../../../../../../assets/svg/conversations.svg',
})
export class ConversationsComponent {}
